import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Client from '../Client';
import { Button, Form, Input } from 'semantic-ui-react';
import HardCodedLocations from '../HardCodedLocations';

class GeocodeSearch extends Component {
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = e => {
    e.preventDefault();
    this.setState({error: null});

    const {address} = this.state;

    Promise.resolve(HardCodedLocations.getLocation(address)).then(location =>
      location ? location : Client.geocode(address)).then(response => {
        this.props.onPositionChanged(response);
      }).catch(e => {
        console.log('Geocode search error:', e); // eslint-disable-line no-console
      });
  }

  render() {
    return (
      <Form size="large" onSubmit={this.handleSubmit}>
        <Input type='text' placeholder='Search location (city, state)' name='address' fluid onChange={this.handleChange}>
          <input />
          <Button type='submit' icon='search' content='Search' style={{backgroundColor: '#FF80AC', color: 'white'}} />
        </Input>
      </Form>
    );
  }
}

GeocodeSearch.propTypes = {
  onPositionChanged: PropTypes.func.isRequired
};

export default GeocodeSearch;
